export default "__VITE_ASSET__DMeAX5qi__"